import { useAppDispatch } from 'store/hooks';
import { closeModal } from 'features/modal/modalSlice';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog';
import { stopRestreamingRequest } from 'features/restreamer/restreamerSlice';
import { useRestreamer } from 'features/restreamer/useRestreamer';

const StopRestreamingConfirmation = () => {
  const { t } = useTranslation('modals');

  const dispatch = useAppDispatch();

  const { isFeatureAvailable } = useRestreamer();

  useEffect(() => {
    if (!isFeatureAvailable) {
      dispatch(closeModal('stopRestreamingConfirmation'));
    }
  }, [isFeatureAvailable, dispatch]);

  const handleOk = () => {
    dispatch(stopRestreamingRequest());
    dispatch(closeModal('stopRestreamingConfirmation'));
  };

  const handleCancel = () => {
    dispatch(closeModal('stopRestreamingConfirmation'));
  };

  return (
    <ConfirmationDialog
      open
      maxWidth="xs"
      title={t('restreaming.stop_confirmation.title')}
      description={t('restreaming.stop_confirmation.description')}
      cancelText={t('restreaming.stop_confirmation.btn_cancel_label')}
      okText={t('restreaming.stop_confirmation.btn_ok_label')}
      onOk={handleOk}
      onCancel={handleCancel}
      preventClose
      hideCloseButton
    />
  );
};

export default StopRestreamingConfirmation;
